import { render, staticRenderFns } from "./Mockups.vue?vue&type=template&id=2b142898&scoped=true&"
import script from "./Mockups.vue?vue&type=script&lang=js&"
export * from "./Mockups.vue?vue&type=script&lang=js&"
import style1 from "./Mockups.vue?vue&type=style&index=1&id=2b142898&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b142898",
  null
  
)

export default component.exports